import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { Coupon } from '../../models/coupons/coupon-model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';




@Injectable()
export class CouponsService {
  private serviceName = 'api/coupons';
  private serviceUtility = "api/Utility"; //Controller Name
  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }

  AddCoupon(couponTypemodel: Coupon) {
    return this.http
      .post(`${this.serviceName}`, couponTypemodel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetDomainTypes() {
    return this.http.get(`${this.serviceUtility}/GetDomainTypes`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  updateCoupon(couponTypemodel: Coupon){
    //Todo
    return this.http
      .put(`${this.serviceName}`, couponTypemodel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  deleteCoupon(id: string) {
    return this.http.delete(`${this.serviceName}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getCoupons() {
    return this.http.get(`${this.serviceName}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getCouponsGrid(pageNumber: number, pageSize: number, searchKeyword: string, isActive: string, discountTypeId: number) {
      return this.http.get(`${this.serviceName}/CouponsGrid?pageNumber=` + pageNumber + `&pageSize=` + pageSize + `&searchKeyword=` + searchKeyword + `&isActive=` + isActive + `&discountTypeId=` + discountTypeId,{
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  getCoupon(id: string) {
    return this.http.get(`${this.serviceName}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  isUniqueCode(couponCode: string, id: number) {
    return this.http.get(`${this.serviceName}/CouponCodeExits?couponCode=` + couponCode + '&Id=' + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/coupons/coupons.service.ts